import { render } from "./CardSlider.vue?vue&type=template&id=e0e38a40&scoped=true"
import script from "./CardSlider.vue?vue&type=script&lang=js"
export * from "./CardSlider.vue?vue&type=script&lang=js"

import "./CardSlider.vue?vue&type=style&index=0&id=e0e38a40&scoped=true&lang=css"

import exportComponent from "/Users/juvicmartires/Documents/BreakingHits/breakinghits-vuejs-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e0e38a40"]])

export default __exports__